/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{getDefaultUnitSystem as t}from"../core/unitUtils.js";import r from"../portal/Portal.js";function e(e){const n="metric";if(null==e)return n;const i=e.map,l=(i&&"portalItem"in i?i.portalItem?.portal:null)??r.getDefault();switch(l.user?.units??l.units){case n:return n;case"english":return"imperial"}return t(e.spatialReference)??n}export{e as getDefaultUnitForView};
